import { Route, Routes } from 'react-router-dom'
import { AppShell } from './components/layout/AppShell'
import { HomePage } from './pages/HomePage'
import { NotFoundPage } from './pages/NotFoundPage'
import { SettingsPage } from './pages/SettingsPage'
import { EventDetailPage } from './pages/EventDetailPage'
import type { PredictionCategory } from './types/prediction'
import { LocaleProvider } from './i18n/locale'

const categoryRoutes: PredictionCategory[] = ['finance', 'technology', 'world', 'sports', 'entertainment', 'crypto']

function App() {
  return (
    <LocaleProvider>
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<HomePage />} />
          {categoryRoutes.map((category) => (
            <Route key={category} path={category} element={<HomePage categoryOverride={category} />} />
          ))}
          <Route path="event/:eventId" element={<EventDetailPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </LocaleProvider>
  )
}

export default App
